// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","container":"OpacityOptions_container__2lYHg"};